const IconWallet = ({ width = 20, height = 20, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8.5V6.22222C15 5.89807 14.8717 5.58719 14.6434 5.35798C14.4151 5.12877 14.1055 5 13.7826 5H2.21739C1.89452 5 1.58487 5.12877 1.35657 5.35798C1.12826 5.58719 1 5.89807 1 6.22222V14.7778C1 15.1019 1.12826 15.4128 1.35657 15.642C1.58487 15.8712 1.89452 16 2.21739 16H13.7826C14.1055 16 14.4151 15.8712 14.6434 15.642C14.8717 15.4128 15 15.1019 15 14.7778V12"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3L11.9146 1.02451C11.9923 1.00055 12.0737 0.994067 12.1537 1.00546C12.2338 1.01685 12.3109 1.04587 12.3804 1.09078C12.4499 1.13568 12.5104 1.19554 12.5582 1.26674C12.606 1.33794 12.6401 1.419 12.6585 1.50504L13 3"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4286 9H13.5714C13.2558 9 13 9.3349 13 9.6V11.4C13 11.6651 13.1844 12 13.5 12H15H16.5C16.8156 12 17 11.6651 17 11.4V9.6C17 9.3349 16.7442 9 16.4286 9Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconWallet;
